const intAtIndex = (value, index) => Number.parseInt(value.charAt(index), 10);

export function isValidRoutingNumber(value) {
  if (typeof value !== 'string' || value.length !== 9) return false;

  const x = 3 * (intAtIndex(value, 0) + intAtIndex(value, 3) + intAtIndex(value, 6));
  const y = 7 * (intAtIndex(value, 1) + intAtIndex(value, 4) + intAtIndex(value, 7));
  const z = intAtIndex(value, 2) + intAtIndex(value, 5) + intAtIndex(value, 8);
  const checksumTotal = x + y + z;

  return checksumTotal % 10 === 0;
}
